import React, { useEffect } from "react"

import { Flow } from "@tenforce/product-fields"

import { ITenForceWindow } from "../../../global"
import { useAppSelector, useAppDispatch } from "../../../hooks"
import { GlobalState } from "../../../store"

import * as FlowPanelSelectors from "../selectors"
import { setVisibility } from "../slice"

declare let window: ITenForceWindow

export const FlowPanel = (): JSX.Element => {
    const dispatch = useAppDispatch()

    const { isVisible } = useAppSelector(
        (state: GlobalState) => state.flowPanel,
    )

    const isFlowPanelDataAvailable = useAppSelector((state: GlobalState) =>
        FlowPanelSelectors.isFlowPanelDataAvailable(state.flowPanel),
    )

    const flow = useAppSelector((state: GlobalState) =>
        FlowPanelSelectors.getFlow(state.flowPanel),
    )

    useEffect(() => {
        dispatch(setVisibility(isFlowPanelDataAvailable))
    }, [isFlowPanelDataAvailable])

    useEffect(() => {
        window.env.setFlowPanelVisibility(isVisible && isFlowPanelDataAvailable)
    }, [isVisible, isFlowPanelDataAvailable])

    if (!isFlowPanelDataAvailable || !isVisible) {
        return <></>
    }

    return (
        <div className="tw-py-4" data-ft-component="flowPanel">
            <Flow {...flow} />
        </div>
    )
}

export default FlowPanel
